// AppLayout.tsx
import { useLocation } from 'react-router-dom';
import Footer from "shared/Footer/Footer";
import SiteHeader from "containers/SiteHeader";
import FooterNav from "components/FooterNav";
import useWindowSize from "hooks/useWindowResize";


const HIDDEN_LAYOUT_ROUTES = ['/pdf'];

const AppLayout = ({ children }: { children: React.ReactNode }) => {

let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }
  const { pathname } = useLocation();
  const hideLayout = HIDDEN_LAYOUT_ROUTES.includes(pathname);

  return (
    <>
      {!hideLayout && <SiteHeader />}
      {children}
      {WIN_WIDTH < 768 && !hideLayout && <FooterNav />}
      {!hideLayout && <Footer />}
    </>
  );
};

export default AppLayout;
